import React from "react";

export default (props: any) => {
  
  return (<button className={"btn--share"} disabled={props.disabled} onClick={() => props.onClick()}>
    <img src={"https://static.myshortlist.co/btn-share.svg"} />
  </button>);
}